/**
 * #1179 / #1188 / #1180 — why a value needs the dealer's review, in words. The
 * keys are the `review_reason` values the merge writes on field-source rows.
 */
export const REVIEW_REASON_LABELS: Record<string, string> = {
  photo_conflict: 'The photos show something different.',
  photo_suggestion: 'Read from a photo — check it before using it.',
  hin_year_conflict: 'The HIN says a different model year.',
  hin_possible_misread: 'The HIN may be misread — check it against the plate.',
  vin_check_digit_failed: 'The trailer VIN check digit does not match — check it.',
  engine_serial_near_match: 'The engine serial is one character away from a known engine.',
  spec_lookup: 'Found in catalogue — check it before using it.',
};

export function reviewReasonLabel(reason: string | null | undefined): string | null {
  return reason ? (REVIEW_REASON_LABELS[reason] ?? null) : null;
}
